import { siteGeometryStore } from "../store";

export const abortSiteGeometryRequest = () => {
  if (!siteGeometryStore.activeRequestAbort) return;
  siteGeometryStore.activeRequestAbort();
  siteGeometryStore.activeRequestAbort = undefined;
};
